module.exports = __webpack_public_path__ + "static/img/mofa-csp.a41bd94.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/mofa-csp.jpg
// module id = Ta7q
// module chunks = 0